module.exports = __webpack_public_path__ + "static/media/Acrilico (29).e65d0c9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (29).jpg
// module id = 297
// module chunks = 0